// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2nibI","range":"MonthRangeSwitch_range__3zXIR","disabled":"MonthRangeSwitch_disabled__qSAZL"};